import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { Check, ChevronDown, X } from 'lucide-react';

const norm = (o) => (typeof o === 'string' ? { value: o, label: o } : o);

export const MultiSelectFilter = ({ label, options = [], value = [], onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const opts = options.map(norm);
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  const summary = value.length === 0 ? 'All' : value.length === 1 ? (opts.find((o) => o.value === value[0])?.label || value[0]) : `${value.length} selected`;
  return (
    <div className="flex flex-col gap-1 min-w-0">
      <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{label}</span>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            data-testid={`${testId}-trigger`}
            className={`h-9 px-3 rounded-md border text-sm flex items-center justify-between gap-2 bg-white transition-colors hover:border-slate-400 ${value.length ? 'border-indigo-400 text-indigo-700' : 'border-slate-200 text-slate-700'}`}
          >
            <span className="truncate">{summary}</span>
            {value.length ? (
              <X size={14} className="shrink-0" data-testid={`${testId}-clear`} onClick={(e) => { e.stopPropagation(); onChange([]); }} />
            ) : (
              <ChevronDown size={14} className="shrink-0 text-slate-400" />
            )}
          </button>
        </PopoverTrigger>
        <PopoverContent className="p-0 w-72" align="start">
          <Command>
            <CommandInput placeholder={`Search ${label.toLowerCase()}…`} data-testid={`${testId}-search`} />
            <CommandList className="max-h-64">
              <CommandEmpty>No results</CommandEmpty>
              <CommandGroup>
                {opts.map((o) => (
                  <CommandItem key={o.value} value={o.label} onSelect={() => toggle(o.value)} data-testid={`${testId}-option-${o.value}`}>
                    <Check size={14} className={`mr-2 ${value.includes(o.value) ? 'opacity-100 text-indigo-600' : 'opacity-0'}`} />
                    <span className="truncate">{o.label}</span>
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
};
